<template>
  <div class="notice-info">
    <template>
      <el-backtop>顶部</el-backtop>
    </template>
    <div class="ms">
      首页 <i class="el-icon-arrow-right"></i> 竞买预告
      <i class="el-icon-arrow-right"></i>预告详情
    </div>
    <div class="notice-info-header">
      <div class="product-introduction">
        <div class="product-preview">
          <PreviewSlide :banners="banners"></PreviewSlide>
        </div>
        <div class="product-property-wrapper">
          <div class="product-property product-property-pend">
            <div class="product-property-body">
              <div class="product-property-left">
                <div class="product-property-attach">
                  <ul style="margin-top:10px">
                    <li class="titleLi">
                      {{ detailBaseInfo.title }}
                    </li>
                    <li class="ggbh">预告编号：{{ detailBaseInfo.code }}</li>
                    <div class="end-time">
                      <span class="endSpan">距报名截止：</span>
                      <MyCountDown
                        :startTime="detailBaseInfo.systemDate"
                        :endTime="detailBaseInfo.enrollEndTime"
                        @finished="onCountDownEnd"
                      ></MyCountDown>
                    </div>

                    <div class="operationsy">
                      <!-- <el-button type="primary" @click="checkEnroollGet"
                        >立即报名</el-button
                      >
                      <el-button type="primary" @click="onFeedback"
                        >查看预约反馈</el-button
                      > -->
                      <!-- 按钮code 1：立即报名</br>2：资格审核中</br>3：重新报名</br>4：查看看货时间</br>12：报名已截止</br>13：报名成功 -->
                      <el-button
                        type="primary"
                        @click="signUp"
                        :disabled="buyerButton.code === 12"
                        v-if="buyerButton.code"
                        >{{ buyerButton.name }}
                      </el-button>
                    </div>
                    <li class="lis2">
                      <span
                        >报名截止时间：{{ detailBaseInfo.enrollEndTime }}</span
                      >
                    </li>
                    <li class="lis2">
                      <span
                        >看货开始时间：{{
                          detailBaseInfo.inspectStartTime
                        }}</span
                      >
                    </li>
                    <li class="lis2">
                      <span
                        >看货截止时间：{{ detailBaseInfo.inspectEndTime }}</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divs">
          <div>
            <div style="background: #ffffff; padding: 10px ; min-height: 417px">
              <el-tabs v-model="activeName" :stretch="true">
                <el-tab-pane label="预告信息" name="notice">
                  <ul class="ggul">
                    <li>
                      <span class="label">购买资格审核：</span>
                      {{
                        detailBaseInfo.enrollExamine === 1
                          ? '需审核'
                          : '无需审核'
                      }}
                    </li>
                    <li>
                      <span class="label">资质证照要求：</span>
                      <span
                        style="color: #427bd4; cursor: pointer"
                        @click="onDetail"
                        >点击查看详细信息</span
                      >
                    </li>
                    <li style="display: flex;">
                      <span class="label">物资所在地：</span>
                      <span>
                        {{ detailBaseInfo.proviceName }}
                        {{ detailBaseInfo.cityName }}
                        {{ detailBaseInfo.countyName }}</span
                      >
                    </li>
                  </ul>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="header" style="margin:10px 0"></div>
    <div class="notice-info-body">
      <div class="notice-info-container">
        <ProductInfoDetail
          ref="detailInfo"
          :detailData="detailBaseInfo"
          :systemDate="detailBaseInfo.systemDate"
          :bidEndTime="detailBaseInfo.bidEndTime"
          :foretell="1"
        ></ProductInfoDetail>
      </div>
    </div>
    <el-dialog
      title="网上竞买风险声明"
      :visible.sync="remarkDialogVisible"
      :show-close="false"
      width="800px"
      class="remark-dialog"
    >
      <div class="remartk-content">
        <p>
          1.因注册信息不准确、资料提供不完善、竞买保证金缴纳不及时，造成购买商无法参与竞价的，本平台不承担任何责任。
        </p>
        <p>
          2.购买商的竞买账号和密码因泄露、丢失、遗忘登录密码而产生的一切后果，本平台不承担任何责任。
        </p>
        <p>
          3.由于互联网可能出现不稳定情况，不排除网络竞价发生故障（包括但不限于网络故障、电路故障、系统故障）以及被网络黑客恶意攻击，或因购买商自身终端设备和网络异常等原因导致无法正常参与竞价的，本平台不承担任何责任。
        </p>
        <p>
          4.对于因不可抗力或本系统程序不能控制的因素导致服务中断、报价中断或其他缺陷，本平台不承担任何责任。
        </p>
        <p>
          5.易派客平台为本规则所称废旧物资处置交易提供交易平台、信息发布和交易服务等，不属于交易主体；网络竞价交易文件均系根据有关规定及处置商提供的文件资料所制订；易派客平台所作的描述、评价和介绍，均属参考性意见，不承担对处置物资本身、处置物资瑕疵的任何担保。
        </p>
        <p>6.由于上述因素导致物资处置失败的，本平台不承担任何责任。</p>
      </div>
      <div slot="footer" class="remark-footer">
        <div>
          <el-checkbox v-model="isAgreement"
            >本人（公司）对上述条款已认真阅读、充分理解，并承诺完全遵守。</el-checkbox
          >
        </div>
        <div>
          <el-button
            type="primary"
            @click="saveBuyerdocconfirm"
            :disabled="!isAgreement"
            >前往报名</el-button
          >
          <el-button @click="onRemarkCancel">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="废旧物资处置专区运营规则"
      :visible.sync="ruleDialog"
      width="800px"
      center
      custom-class="ruleDialog"
    >
      <OperationRule />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onAgreeRule">同意</el-button>
        <el-button @click="onDisAgreeRule">不同意</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import config from '@/config'
import ProductInfoDetail from './ProductInofDetail'
import OperationRule from '@/views/doc/OperationRule'
import print from 'vue-print-nb'

export default {
  name: 'NoticeInfoDetail',
  components: {
    ProductInfoDetail,
    OperationRule
  },
  directives: {
    print
  },
  filters: {},
  mixins: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      buyerButton: {},
      disabledButton: false,
      buyerNoticeButtonObj: {},
      maxpriceSupp: '',
      maxpriceplate: '',
      timeV: '',
      maxpricest: 0,
      newProduct: [],
      maskStatus: null,
      checkedflag: true,
      formalways: [],
      invoiceOptions: [],
      checked: true,
      nameV: '',
      maxprice: 'startPrice',
      moremax: null,
      recordTotalV: [],
      recordTotalVNum: 0,
      labelV: '',
      offernumber: null,
      ruleDialog: false,
      printDataTable: [],
      printData: {}, //存放打印成交确认书数据
      printResult: false,
      ruleLink: '', // 竞价规则链接
      remarkDialogVisible: false,
      isAgreement: false,
      isLogin: false,
      detailBaseInfo: {
        bidEndTime: '',
        systemDate: ''
      },
      noticeNewList: [],
      // 轮播图
      banners: [],
      asOfV: '',
      enroollStatus: [
        {
          value: null,
          label: '立即报名'
        }
        // {
        //   value: 0,
        //   label: '待资格审核'
        // },
        // {
        //   value: 1,
        //   label: '查看报名'
        // },
        // {
        //   value: 2,
        //   label: '重新报名'
        // }
      ],
      taxArr: ['不含税', '含税'],

      invoiceTitleOptions: [],
      form: {
        type: 0,
        invoiceTitle: '',
        taxpayerCode: '',
        regAddress: '',
        regPhone: '',
        bankName: '',
        bankAccountName: '',
        mailAddress: ''
      },

      delay: 1000 * 5,
      dialogVisible: false,
      acceptWhether: 0,
      timer: null,
      eject: 1,
      money: 0,
      activeName: 'notice',
      bidType: [
        {
          value: '05',
          label: '含税单价'
        },
        {
          value: '10',
          label: '含税总价'
        }
      ],
      dialogVisiblefwf: false,
      hasActive: false
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    },
    ...mapState({
      recordTotal: state => state.recordTotal
    })
  },
  watch: {},
  created() {
    this.timer = setInterval(() => {
      this.buyerPreNoticeButton()
      this.checkNoticeDetail()
    }, this.delay)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  mounted() {
    this.ruleLink = config.RULEURL
    this.getNoticeInfo()
    this.buyerPreNoticeButton()
    // this.getNoticeItem()
    // this.buyerNoticeButton()
  },
  methods: {
    ...mapMutations(['setRecordTotal']),
    //资质证照
    onDetail() {
      const scrollTop =
        document.getElementById('enrollExamineRef').offsetTop - 120
      document.documentElement.scrollTop = scrollTop
    },
    //是否登录
    async checkNoticeDetail() {
      let data = await this.$api.notice.checkNoticeDetail()
      this.isLogin = data
      localStorage.setItem('isLogin', JSON.stringify(data))
    },
    //页面按钮
    async buyerNoticeButton() {
      let data = await this.$api.notice.buyerNoticeButton({
        id: this.$route.query.id
      })
      this.buyerNoticeButtonObj = data
    },
    async getNoticeInfo() {
      let params = this.$route.query.id
      let data = await this.$api.notice.getNoticeInfo(params)
      this.detailBaseInfo = {
        ...data,
        // 处理图片和视频地址
        noticeMateList:
          data.mateList &&
          data.mateList.map(item =>
            Object.assign({}, item, {
              mateImgs: item.mateImgs.map(item =>
                Object.assign({}, item, {
                  fileWebpath: config.STATIC_URL + item.fileWebpath,
                  imageUrl: item.fileWebpath
                })
              ),
              mateImgsUrlList: item.mateImgs.map(
                item => config.STATIC_URL + item.fileWebpath
              ),
              mateVideos:
                item.mateVideos &&
                item.mateVideos.map(item =>
                  Object.assign({}, item, {
                    fileWebpath: config.STATIC_URL + item.fileWebpath,
                    imageUrl: item.fileWebpath
                  })
                )
            })
          )
      }
      // console.log(this.detailBaseInfo)
      // 轮播图数据
      this.banners =
        this.detailBaseInfo.noticeMateList &&
        this.detailBaseInfo.noticeMateList.reduce(
          (acc, cur) => acc.concat(cur.mateImgs),
          []
        )
      let mainImg = {} //主图
      this.banners.forEach(item => {
        if (this.detailBaseInfo.imageUrl === item.imageUrl) {
          mainImg = item
        }
      })
      this.banners.unshift(mainImg)
      this.banners = [...new Set(this.banners)]
      this.checkNoticeDetail()
    },

    // 查询所登录购买商是否已确认过竞买风险声明
    async isBuyerdocconfirm() {
      let data = await this.$api.notice.isBuyerdocconfirm(10)
      // console.log(data)
      if (!data) {
        this.remarkDialogVisible = true
      } else {
        let name = 'ApplyEnroollForetell'
        let query
        query = {
          noticeId: this.detailBaseInfo.id,
          pageType: 'create'
        }
        this.$router
          .push({
            name,
            query
          })
          .catch(() => {})
      }
    },
    // 保存购买商竞买风险声明确认信息
    async saveBuyerdocconfirm() {
      let data = await this.$api.notice.saveBuyerdocconfirm(10)
      // console.log(data)
      if (data) {
        this.remarkDialogVisible = false
        let name = 'ApplyEnroollForetell'
        let query
        query = {
          noticeId: this.detailBaseInfo.id,
          pageType: 'create'
        }
        this.$router
          .push({
            name,
            query
          })
          .catch(() => {})
      }
    },
    onRemarkCancel() {
      this.remarkDialogVisible = false
    },
    onDisAgreeRule() {
      this.ruleDialog = false
    },
    async buyerPreNoticeButton() {
      let params = {
        id: this.$route.query.id
      }
      let data = await this.$api.notice.buyerPreNoticeButton(params)
      console.log(data)
      if (data) {
        this.buyerButton = data
      }
    },
    onFeedback() {
      let query = {
        noticeId: this.detailBaseInfo.id,
        inspectId: this.detailBaseInfo.inspectId
      }
      this.$router.push({
        name: 'ApplyInspectForetell',
        query
      })
    },
    onCountDownEnd(val) {
      console.log(val)
      this.disabledButton = true
    },
    async onAgreeRule() {
      const params = {
        ruleNo: OperationRule.name
      }
      await this.$api.notice.agreeOprationRule(params)
      this.ruleDialog = false
      this.isBuyerdocconfirm()
    },
    signUp() {
      //  按钮code 1：立即报名</br>2：资格审核中</br>3：重新报名</br>4：查看看货时间</br>12：报名已截止</br>13：报名成功
      if (this.buyerButton.code == 1) {
        this.checkEnroollGet()
      } else if (this.buyerButton.code == 4) {
        console.log(0)
        this.onFeedback()
      } else {
        let query = {
          noticeId: this.detailBaseInfo.id,
          pageType: 'check'
        }
        this.$router.push({
          name: 'ApplyEnroollForetell',
          query
        })
      }
    },
    //报名
    async checkEnroollGet() {
      console.log(9)
      let data = await this.$api.materialdisposal.buyerCheck()
      // console.log(data)
      if (data === 0) {
        this.$confirm('开通采购商身份后才可报名参与竞买', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false
        })
      } else {
        this.statistics()
      }
    },
    async statistics() {
      const params = {
        noticeId: this.detailBaseInfo.id
      }
      const data = await this.$api.enrooll.checkPreEnrooll(params)
      if (data === 1) {
        this.$confirm('此预告为本公司的预告不可以报名!', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false
        })
          .then(() => {})
          .catch(() => {})
      } else if (data === 2) {
        this.$confirm('您还有保证金未补交，不可以报名!', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false
        })
          .then(() => {
            let query = {
              type: 1
            }
            this.$router.push({ path: 'account/myDeposit', query })
          })
          .catch(() => {})
      } else if (data === 3) {
        this.$confirm(
          '由于您未履行该企业的成交订单，暂时禁止报名该企业的预告!',
          '提示',
          {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }
        )
          .then(() => {})
          .catch(() => {})
      } else if (data === 4) {
        this.$confirm(
          '您在专区违规达3次，按照运营规则本平台将取消您在本专区的交易资格',
          '提示',
          {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }
        )
          .then(() => {})
          .catch(() => {})
      } else if (data === 5) {
        this.$confirm(
          '您在该处置企业的黑名单里，暂时无法报名，请联系处置企业处理',
          '提示',
          {
            confirmButtonText: '确定',
            type: 'warning',
            showCancelButton: false
          }
        )
          .then(() => {})
          .catch(() => {})
      } else {
        this.onEnrooll()
      }
    },
    async onEnrooll() {
      const params = {
        ruleNo: OperationRule.name
      }
      const data = await this.$api.notice.isAgreeOprationRule(params)
      if (!data) {
        if (this.isLogin) {
          this.ruleDialog = true
        }
        return
      }
      this.isBuyerdocconfirm()
    },
    splits(tranvalue) {
      var value = new Array('', '')
      let temp = tranvalue.toString().split('.')
      for (var i = 0; i < temp.length; i++) {
        value[i] = temp[i]
      }
      return value
    }
  }
}
</script>
<style scoped lang="less">
/deep/ .el-tabs__nav {
  width: 100%;
}
/deep/ .el-tabs__item {
  font-weight: bold;
  text-align: center;
}
/deep/ .divs .el-table tr {
  font-size: 12px;
}
/deep/ .divs .el-table thead {
  color: #333333;
}
/deep/ .divs .el-table th {
  font-weight: 500;
  background: unset !important;
}
/deep/ .divs .el-table td {
  padding: 6px 0 !important;
}
.more7 {
  margin-top: 20px;
  font-size: 12px;
  text-align: center;
  span {
    color: #427bd4;
    cursor: pointer;
  }
}
.tacBold {
  font-weight: bold;
}
.tac {
  text-align: center;
  line-height: 20px;
}
.m10 {
  margin: 10px 0;
}
.dealimg {
  width: 120px;
  margin-bottom: 20px;
}
.mycode {
  color: #427bd4;
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  margin-top: 10px;
  span {
    color: #333333;
  }
}
/deep/ .el-table th > .cell {
  text-align: center;
}
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  background: #f5f5f5;
  color: #999999;
  border-color: #f5f5f5;
}
.el-button {
  border-radius: 0;
}
.flexBox2 {
  display: flex;
  justify-content: center;
  align-items: center;

  .btn2 {
    height: 40px;
  }
}
</style>
<style lang="less">
.notice-info {
  max-width: 1200px;
  margin: 0 auto;
  .cj {
    font-weight: bold;
  }
  .el-input-number .el-input__inner {
    color: red;
    font-size: 20px;
    border-radius: 0;
    text-align: left;
  }
  .ms {
    font-size: 14px;
    color: #999999;
    display: flex;
    align-items: center;
    margin: -15px 0 15px;
    i {
      margin: 0 5px;
    }
  }
  .ch-text {
    color: red;
    font-weight: bold;
    padding-bottom: 10px;
    font-size: 18px;
  }
  background: #f8f7f7;
  padding: 30px;
  .product-introduction {
    background: #ffffff;
    display: flex;
    .product-preview {
      width: 350px;
      margin-right: 30px;
    }
    .product-property-wrapper {
      position: relative;
      width: 350px;
      flex: 1;
      .oblique {
        width: 85px;
        height: 50px;
        overflow: hidden;
        position: absolute;
        top: -3px;
        right: -24px;
        .oblique-text {
          color: white;
          text-align: center;
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
          -moz-transform: rotate(45deg);
          -ms-transform: rotate(45deg);
          -o-transform: rotate(45deg);
          position: relative;
          padding: 2px 0;
          left: 35px;
          top: 10px;
          width: 65px;
          background-color: #00801c;
          background-image: -webkit-gradient(
            linear,
            left top,
            left bottom,
            from(#bfdc7a),
            to(#8ebf45)
          );
          background-image: -webkit-linear-gradient(top, #bfdc7a, #8ebf45);
          background-image: -moz-linear-gradient(top, #bfdc7a, #8ebf45);
          background-image: -ms-linear-gradient(top, #bfdc7a, #8ebf45);
          background-image: -o-linear-gradient(top, #bfdc7a, #8ebf45);
          -webkit-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
          -moz-box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
          box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
        }
      }
      .product-property {
        .product-property-header {
          padding: 10px 0;
          border-bottom: 1px solid #ddd;
          .product-property-base {
            display: flex;
            // justify-content: space-between;
            .product-name {
              width: 100%;
              font-size: 18px;
              font-weight: bold;
            }
          }
          .product-tags {
            margin-top: 10px;
            display: flex;
            .product-tag-item {
              display: block;
              padding: 0px 10px;
              line-height: 24px;
              background: #fae6e4;
              border: 1px solid #ff3323;
              font-size: 12px;
              color: #ff3323;
              margin-right: 15px;
            }
          }
        }
        .product-property-body {
          display: flex;
          justify-content: space-between;
          .product-property-left {
            // margin-right: 20px;
            .product-property-attach {
              width: 440px;
              // padding: 5px 15px 25px;
              // border-bottom: 1px solid #ddd;
              ul {
                display: flex;
                flex-flow: wrap;
              }
              li {
                width: 100%;
              }
              .end-time {
                margin: 0 0 20px 0 !important;
                // font-weight: bold;
                color: #333333;
                span {
                  //   font-size: 12px;
                  b {
                    font-weight: bold;
                    font-size: 18px;
                    margin: 0 2px;
                  }
                }
                .delayed-id {
                  cursor: pointer;
                  display: block;
                  padding-bottom: 10px;
                  font-size: 15px;
                  color: #005dcf;
                  float: right;
                  span {
                    color: #333;
                  }
                }
              }
            }
            .product-property-own {
              // padding-left: 15px;
              margin-top: 10px;
              li {
                line-height: 30px;
              }
            }
          }
          .product-property-right {
            flex: 1;
            .section-card .section-card-body {
              // border: 1px solid #febb06;
              border-top: none;
              // padding: 0;
            }
            .section-card-title {
              // border: 1px solid #febb06;
              border-bottom: none;
            }
            .quote-table {
              width: 240px;
              min-height: 200px;
              overflow: auto;
              .el-table td {
                padding: 4px 0;
                font-size: 12px;
              }
            }
            .my-quote-info {
              border: 1px solid #bbbbbb;
              padding: 20px 15px;
              p {
                line-height: 28px;
              }
              span {
                color: #f00000;
              }
            }
          }
        }
      }
      .product-property-footer {
        // padding-left: 15px;
        margin-top: 5px;
        margin-bottom: 30px;
        flex-wrap: wrap;
        line-height: 25px;
        display: flex;
        .el-col {
          padding: 0 5px;
        }
        .el-col-13 {
          padding: 0;
        }
        .product-extra {
          margin-top: 30px;
          .link {
            color: #d51b1c;
            font-size: 16px;
          }
          .link-login {
            line-height: 30px;
            color: #ef0000;
          }
        }
        .button-group {
          text-align: center;
          margin-top: 30px;
        }
      }
      .product-property-pend,
      .product-property-pending,
      .product-property-pended {
        .section-card {
          margin-bottom: 20px;
        }
        .section-card .section-card-body {
          // border: 1px solid #febb06;
          border-top: none;
          padding: 0;
        }
        .address-section {
          .section-card-body {
            padding: 20px;
            p {
              margin-bottom: 15px;
              line-height: 26px;
            }
          }
        }
      }
    }
    .divs {
      width: 320px;
      margin-left: 20px;
      padding-left: 20px;
      background: #f8f7f7;
    }
  }
  .notice-info-body {
    // margin-top: 40px;
    display: flex;
    .notice-info-aside {
      background: #ffffff;
      width: 260px;
      border: 1px solid #dddddd;
      margin-left: 20px;
      .new-notice-list {
        li {
          margin-bottom: 10px;
        }
        .new-notice-list-name {
          line-height: 26px;
          width: 80%;
        }
        .new-notice-list-company {
          color: #777;
          font-size: 12px;
          line-height: 20px;
          width: 90%;
        }
      }
    }
    .notice-info-container {
      flex: 1;
    }
  }
  .dialog-title {
    font-weight: bold;
    margin-bottom: 18px;
    font-size: 16px;
  }
  .el-radio-group {
    margin-top: 10px;
    .el-radio {
      margin-bottom: 15px;
    }
  }
  .remark-dialog {
    .el-dialog__header {
      background-color: #2587ff;
      padding: 10px;
      .el-dialog__title {
        color: #ffffff;
        font-size: 16px;
        font-weight: 700;
      }
      .el-dialog__headerbtn {
        top: 10px;
      }
    }
    .el-dialog__body {
      padding: 20px;
      min-height: 200px;
    }
  }
  .titleLi {
    font-weight: 500;
    font-size: 24px;
    margin-top: 10px;
    line-height: 30px;
  }
  .ggbh {
    margin: 20px 0 20px;
  }
  .li {
    margin-bottom: 16px;
    .label {
      display: inline-block;
      min-width: 105px;
      text-align-last: justify;
    }
    .redBold {
      font-size: 18px;
      font-weight: bold;
    }
    .red2 {
      color: #f0250f;
    }
  }
  .mb0 {
    margin-bottom: 0;
  }
  .lis2 {
    margin-bottom: 15px;
  }
  .endSpan {
    display: inline-block;
  }
}
.table {
  width: 100%;
}
.remarkContent {
  .table-remartk-content {
    width: 584px;
    text-align: left;
    line-height: 32px;
    align-items: center;
    margin: 0 auto;
    & > p + p {
      text-indent: 30px;
    }
    .date_div {
      text-align: right;
    }
  }
  .materialInfo_div,
    // .QuotationRecord_div {
    //   border-top: 2px solid #d7d7d7;
    //   margin-top: 15px;
    //   padding: 0 65px;
    // }
    .QuotationRecord_div {
    // border-top: 2px solid #d7d7d7;
    margin-top: 15px;
    padding: 0 65px;
  }
  .materialInfo_div {
    .materialInfoItem {
      border: 1px solid rgba(215, 215, 215, 1);
      padding: 10px 25px;
      margin-bottom: 10px;
      .el-row {
        border-bottom: 1px solid #f2f2f2;
        & > div {
          line-height: 40px;
        }
      }
    }
  }
  .QuotationRecord_div {
    table {
      td {
        padding: 0;
        height: 35px;
        line-height: 35px;
      }
    }
  }
}
.ruleDialog {
  height: 500px;
  overflow: scroll;
}
.title {
  // font-size: 16px;
  margin-top: 10px;
  margin-bottom: 10px;
  color: #333;
  line-height: 29px;
}
.table-btn {
  margin-top: 20px;
  text-align: center;
  button {
    width: 120px;
    height: 30px;
    // font-family: '微软雅黑', sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    border: 1px solid #2587ff;
    margin: 0 15px;
    background-color: #ffffff;
  }
  .btn-no {
    background-color: #2587ff;
  }
}
.ddd {
  .el-tabs--border-card {
    min-height: 425px;
  }
  .el-tabs--border-card > .el-tabs__content {
    padding: 10px 10px !important;
  }
}
.timebox3 {
  margin-top: 10px;
  line-height: 25px;
}
.checkmore {
  float: right;
  cursor: pointer;
  margin-bottom: 2px;
}
.checkmoreleft {
  float: left;
  cursor: pointer;
  margin-bottom: 2px;
}
.columnleft {
  width: 260px;
  .column-line {
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #ae1c00 12%, #bfbfbf 12%);
  }
  .column-header {
    display: flex;
    justify-content: space-between;
    padding-bottom: 20px;
    .column-icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      background-repeat: no-repeat;
      background-size: cover;
      margin-right: 10px;
      vertical-align: bottom;
    }
    .icon08 {
      background-image: url('../../assets/imgs/indexIcon_14.png');
    }
    .icon09 {
      background-image: url('../../assets/imgs/indexIcon_15.png');
    }
    .title {
      font-size: 22px;
    }
    .column-more {
      font-size: 16px;
      color: #666;
      cursor: pointer;
    }
    .column-more:hover {
      color: #febb08;
    }
  }
  .column-content {
    .product-list {
      width: 100%;
      // display: flex;
      // justify-content: space-between;
      // flex-flow: row wrap;
      margin-top: 20px;
      .product-item {
        // flex: 0 0 25%;
        margin-bottom: 20px;
        .product-wrap {
          width: 240px;
          height: 350px;
          border: 1px solid #e4e4e4;
          cursor: pointer;
          .pic {
            width: 237px;
            height: 162px;
            .img-pic {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            font-size: 18px;
            height: 60px;
            overflow: hidden;
            line-height: 30px;
          }
          .content {
            padding: 15px;
            .content-item {
              color: #7d7d7d;
              margin-bottom: 14px;
              font-size: 14px;
              position: relative;
              .type {
                position: absolute;
                right: -20px;
                top: -6px;
              }
              .type02 {
                position: absolute;
                right: 0px;
                top: -6px;
              }
            }
          }
        }
        .product-wrap:hover {
          border-color: #febb08;
        }
      }
    }
  }
}
.operationsy {
  text-align: center;
  min-height: 120px;
  // border: 1px solid #e4e4e4;
  background: #f4f7ff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 0 25px 0;
  min-width: 400px;
  .tips {
    font-size: 14px;
    margin: 5px 0;
  }
  /deep/ .el-button {
    padding: 10px 30px;
  }
}
.operationsy2 {
  background: #ffffff;
}
.workflowimg {
  margin: 10px 0;
}
// .workflow {
//   background: white;
//   display: flex;
//   // border: 1px solid #e4e4e4;
//   margin: 20px auto;
//   height: 98px;
//   .workflow-tips {
//     position: relative;
//     top: -4px;
//     left: -1px;
//     width: 150px;
//     height: 102px;
//     background-image: url('../../assets/imgs/indexIcon_05.png');
//     background-repeat: no-repeat;
//     background-size: cover;
//     margin-right: 40px;
//   }
//   .workflow-content {
//     display: flex;
//     .flow-item {
//       text-align: center;
//       padding-top: 14px;
//       width: 73px;
//       .flow-icon {
//         display: inline-block;
//         width: 42px;
//         height: 42px;
//         background-repeat: no-repeat;
//         background-size: cover;
//       }
//       .flow-text {
//         padding-top: 5px;
//         font-size: 14px;
//         color: #666;
//       }
//       .arrow {
//         margin-top: 22px;
//         display: inline-block;
//         width: 24px;
//         height: 24px;
//         background-repeat: no-repeat;
//         background-size: cover;
//         background-image: url('../../assets/imgs/indexIcon_13.png');
//       }
//       .icon01 {
//         background-image: url('../../assets/imgs/indexIcon_10.png');
//       }
//       .icon02 {
//         background-image: url('../../assets/imgs/indexIcon_11.png');
//       }
//       .icon03 {
//         background-image: url('../../assets/imgs/indexIcon_12.png');
//       }
//       .icon04 {
//         background-image: url('../../assets/imgs/indexIcon_08.png');
//       }
//       .icon05 {
//         background-image: url('../../assets/imgs/indexIcon_07.png');
//       }
//       .icon06 {
//         background-image: url('../../assets/imgs/indexIcon_09.png');
//       }
//       .icon07 {
//         background-image: url('../../assets/imgs/indexIcon_06.png');
//       }
//     }
//   }
// }
.warning {
  margin-top: -15px;
  .warning-info {
    font-size: 16px;
    color: rgb(221, 105, 10);
  }
  .warning-icon {
    display: flex;
    justify-content: space-between;
    display: inline-block;
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-size: cover;
    margin-right: 10px;
    vertical-align: bottom;
  }
  .iconwarning {
    background-image: url('../../assets/imgs/indexIcon_20.png');
  }
}
// .print {
//   margin-left: 80px;
// }
.confirm-result {
  display: flex;
  text-align: left;
  justify-content: space-around;
  .confirm-result-radio {
    width: 270px;
  }
  .confirm-result-label {
    padding-top: 10px;
    font-size: 12px;
    width: 90px;
  }
  .el-radio__label {
    font-size: 12px;
  }
  .el-form-item__label {
    font-size: 12px;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 5px;
  }
  .btn {
    margin-top: 8px;
    font-size: 12px;
  }
  .el-input__inner {
    width: 160px;
  }
  .el-input {
    width: 160px;
  }
}
.ggul {
  margin-left: 20px;
}
.ggul li {
  color: #333333;
  font-size: 14px;
  line-height: 32px;
  .label {
    min-width: 120px;
    color: #666666;
    display: inline-block;
    text-align-last: justify;
    margin-right: 5px;
  }
  .red2 {
    color: #f0250f;
  }
  .bold {
    font-size: 16px;
    font-weight: bold;
  }
}
.isInspectstyle {
  width: 120px;
  margin-left: 0px;
}
.isInspectnostyle {
  width: 240px;
  margin-left: -12px;
}
</style>
